import { useContext, useMemo, type ReactNode } from "react";
import { BrowserRouter, UNSAFE_NavigationContext, type BrowserRouterProps } from "react-router-dom";
import { createGuardedNavigator, NavigationGuardContext } from "./navigationGuard";

/** Supply guarded navigation without changing the navigator owned by the router. */
export function NavigationGuardProvider({ children }: { children: ReactNode }) {
  const navigation = useContext(UNSAFE_NavigationContext);
  const controller = useMemo(
    () => createGuardedNavigator(navigation.navigator),
    [navigation.navigator]
  );
  const value = useMemo(
    () => ({ ...navigation, navigator: controller.navigator }),
    [navigation, controller]
  );

  return (
    <NavigationGuardContext.Provider value={controller.register}>
      <UNSAFE_NavigationContext.Provider value={value}>
        {children}
      </UNSAFE_NavigationContext.Provider>
    </NavigationGuardContext.Provider>
  );
}

export function GuardedBrowserRouter({ children, ...props }: BrowserRouterProps) {
  return (
    <BrowserRouter {...props}>
      <NavigationGuardProvider>{children}</NavigationGuardProvider>
    </BrowserRouter>
  );
}
